/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Grid, Card, CardMedia, CardContent, Typography } from '@material-ui/core';

import { useQuery } from '@apollo/client'
import { GET_ADVERTISEMENT } from '../../queries'

import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader
import { Carousel } from 'react-responsive-carousel'
import { usePhotoBaseData } from '../../context/PhotoBasicDataContext'
import { useThemeData } from '../../context/ThemeDataContext'
import { useAuthData } from '../../context/AuthProvider'
import GeneralButton from "../Buttons";
import GeneralText from "../Fonts";


function Advertisement (props) {
  const APP_URL = process.env.REACT_APP_SITE_URL
  const {site_id} = useThemeData().themeData.site;
  const {border_radius_2, primary_color_3, primary_color_4, background_color_7} = useThemeData().themeData.site.theme;
  const {auth} = useAuthData();
  const {default_photo_id} = usePhotoBaseData().photoDefaultSettings;
  const [photo_id] = useState(window.location.pathname.split('/'))
  const [mode, setMode] = useState(null)
  const keuzeset_id = usePhotoBaseData().photoDefaultSettings.default_keuzeset_id
  const [select_photo_id, setSelectPhotoID] = useState(default_photo_id)

  const { loading: loadingAdvertisement, error: errorAdvertisement, data: dataAdvertisement } =
    useQuery(GET_ADVERTISEMENT, {
      variables: {
        site_id: site_id,
        keuzeset_id: keuzeset_id,
      },
      skip: !auth || site_id === '' || !keuzeset_id //if variable is true it will skip the query
    })

  const PHOTO_URL = process.env.REACT_APP_PHOTO_URL

    function renderDiscountDetails(detail) {
        if (detail.korting_pakketten_aantal && detail.korting_pakketten_perc) {
            return `${props.t('shoppage:With a quantity of ')}${detail.korting_pakketten_aantal} ${props.t('shoppage:Or more of this package you will receive ')}${detail.korting_pakketten_perc}% ${props.t('shoppage:Discount')}`;
        } else if (detail.quantum_aantal && detail.quantum_perc) {
            return `${props.t('shoppage:With a quantity of ')}${detail.quantum_aantal} ${props.t('shoppage:Or more of this product you will receive ')}${detail.quantum_perc}% ${props.t('shoppage:Discount')}`;
        } else if (detail.actie_prijs && detail.actie_prijs !== '0,00') {
            return `${props.t('advertisement:Now only')}: €${detail.actie_prijs}`;
        } else {
            return null; // No discount details available
        }
    }

  useEffect(() => {
    /** moet verder naar gekeken worden prop komt te laat **/
    if (default_photo_id != null && photo_id[3] === undefined) {
      setSelectPhotoID(default_photo_id)
    } else {
      setSelectPhotoID(photo_id[3])
    }
  }, [setSelectPhotoID, photo_id, default_photo_id])

  if (loadingAdvertisement || errorAdvertisement || !dataAdvertisement || dataAdvertisement.advertisement[0] === undefined) return null

  if (dataAdvertisement.advertisement[0].products === null) {
    if (mode !== 'view') {
      return (null)
    }
  } else {

    return (<>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="col-title"
           style={{
             backgroundColor: `${background_color_7}`,
             border: `1px solid ${background_color_7}`,
             borderRadius: `${border_radius_2} ${border_radius_2} 0px 0px`,
             color: `${primary_color_3}`,
               marginBottom: '0',
               paddingBottom: '0',
           }}>
          	<GeneralText
              className="sidebar-title"
              variant="h6"
            >
              {props.t('shoppage:Discounts')}
            </GeneralText>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="top-col advertisements" style={{
          marginTop: '0',
          paddingTop: '0',
      }}>
          <Carousel
              infiniteLoop={true}
              autoPlay={true}
              renderIndicator={false}
              showStatus={false}
              showThumbs={false}
              containerClass="carousel"
          >
              {dataAdvertisement.advertisement.map((products, i) => (
                  products.products.map((product, j) => {
                      if (product.productdetail && product.productdetail.actie_prijs && i === 0) {
                          if (j === 0 && mode !== 'view') {
                              setMode('view')
                          }
                          return (
                              <Card className="carousel-product-card">
                                  <CardContent
                                      key={product.product_id}
                                      className={`ad-background`}
                                      style={product.productdetail.actie_afbeelding ? { backgroundImage: `url(${PHOTO_URL}${site_id}/acties/${product.productdetail.actie_afbeelding})` } : {}}
                                  >
                                      <div className="card-body-size">
                                          {/* Placeholder for maintaining the body for the background image */}
                                      </div>
                                  </CardContent>

                                  <CardMedia className="ad-padding">
                                      <Grid container direction="row" className="text-container-ads">
                                          {product.productdetail.actie_afbeelding && (
                                              <Grid item xs={2} className="product-image">
                                                  <img src={`${APP_URL}${site_id}/producten/${product.productdetail.actie_afbeelding}`} alt="Product Action" />
                                              </Grid>
                                          )}
                                          <Grid item xs={product.productdetail.actie_afbeelding ? 10 : 12}>
                                              <Typography
                                                  align={product.productdetail.actie_afbeelding ? "left" : "center"}
                                                  className="font-size-h2"
                                                  gutterBottom
                                                  variant="h5"
                                                  component="h2"
                                              >
                                                  {product.productdetail.naam}
                                              </Typography>
                                              <Typography
                                                  align={product.productdetail.actie_afbeelding ? "left" : "center"}
                                                  className="product-details"
                                                  variant="body2"
                                                  color="textSecondary"
                                                  component="p"
                                              >
                                                  {renderDiscountDetails(product.productdetail)}
                                              </Typography>
                                          </Grid>
                                      </Grid>
                                  </CardMedia>
                              </Card>
                          );
                      } else {
                          return null;
                      }
                  })
              ))}
          </Carousel>

        {

          (() => {
            if (mode !== 'view') {
              return (<Grid container direction="row" className="top-card">
                <div className="card-body-size">
                </div>
              </Grid>)
            }
            if (mode === 'view') {
              return (
                <Link
                  style={{ color: `${primary_color_4}` }}
                  to={`/shoppage/photo_id/${select_photo_id}/adds`}
                  className="__imagelink">
                  <GeneralButton
                    className="btn btn-secondary btn-bttm-margin width-fill"
                    style={{
                      margin: '0.2rem 0rem 0.5rem 0rem'
                    }}
                  >
                    {props.t('advertisement:View all advertisements')}
                  </GeneralButton>

                </Link>
              )
            }
          })()
        }
      </Grid>
    </>)
  }
}

export default React.memo(withTranslation(['message', 'advertisement'])(Advertisement))
